import { render, staticRenderFns } from "./CustomerYanJianKangQuXianSub.vue?vue&type=template&id=7afe8f30&"
import script from "./CustomerYanJianKangQuXianSub.vue?vue&type=script&lang=js&"
export * from "./CustomerYanJianKangQuXianSub.vue?vue&type=script&lang=js&"
import style0 from "./CustomerYanJianKangQuXianSub.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports